import { AfterViewInit, Component, input, output } from '@angular/core';
import { MatChip, MatChipRemove, MatChipSet } from '@angular/material/chips';
import {
  FacetChipDirective,
  WidthInAnimation,
  WidthOutAnimation,
} from '@exl-ng/mulo-common';
import { FacetQuery } from '../facets.model';
import { SvgViewboxDirective } from '@exl-ng/mulo-core';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { CdkAriaLive } from '@angular/cdk/a11y';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'mulo-facets-active',
  templateUrl: './facets-active.component.html',
  styleUrls: ['./facets-active.component.scss'],
  animations: [WidthInAnimation, WidthOutAnimation],
  host: {
    // role: 'application',
    class: 'mulo-facets-active',
    '[class.is-disabled]': 'disabled()',
  },
  imports: [
    MatChipSet,
    NgTemplateOutlet,
    MatChip,
    CdkAriaLive,
    MatIconButton,
    MatIcon,
    SvgViewboxDirective,
    MatChipRemove,
    FacetChipDirective,
    MatButton,
  ],
})
export class FacetsActiveComponent implements AfterViewInit {
  readonly lockedItemsAriaLabel = input('Locked Items');
  readonly activeItemsAriaLabel = input('Search filters');
  readonly unlockBtnAriaLabel = input('Unlock');
  readonly lockBtnAriaLabel = input('Lock');
  readonly removeBtnAriaLabel = input('Remove');
  readonly rememberAllLabel = input('Remember filters');
  readonly resetLabel = input('Reset filters');
  readonly excludedA11yLabel = input('Excluded: ');

  readonly lockable = input(true);
  readonly showActions = input(true);
  readonly disabled = input(false);

  readonly activeItems = input<FacetQuery[]>([]);
  // @Input() lockedItems: FacetQuery[] = [];

  readonly lock = output<FacetQuery>();
  // @Output() unlocked= new EventEmitter<FacetQuery>();
  readonly remove = output<FacetQuery>();
  readonly lockAll = output();
  readonly removeAll = output();

  // @ViewChild(MatChipListbox) chipList: MatChipListbox;
  // @ViewChildren(MatChip) chips: QueryList<MatChip>;

  hoveredItem: number | null = null;
  focusedItem: number | null = null;

  constructor() {}

  ngAfterViewInit(): void {
    this.updateDecendantsChipsInChiplist();
  }

  handleLock(item: FacetQuery) {
    this.lock.emit(item);
  }

  // handleUnlock(item: FacetQuery) {
  //   this.unlocked.emit(item);
  // }

  handleRemove(item: FacetQuery) {
    // let index = this.activeItems.findIndex(i => i.key === item.key )
    // this.activeItems.splice(index, 1)
    // setTimeout(() => {
    this.remove.emit(item);
    // }, 0);
  }

  handleRememberAllClick() {
    this.lockAll.emit();
  }

  handleResetClick() {
    this.removeAll.emit();
  }

  trackByFn(index: number, item) {
    return item.key;
  }

  /**
   * ! Accessibility.
   *  Update the aria roles for chip list
   */
  private updateDecendantsChipsInChiplist() {
    // this.chipList.chips = this.chips;
    // this.chipList.ngAfterContentInit();
  }
}
